/*
 * PERF 04-10 (F2a-1) — <toggle-ellipsis> sem leituras de geometria forcadas.
 *
 * Porte fiel da classe ToggleEllipsis do theme.js (Broadcast 6.1.0, theme.dev.js l. 8355-8398; no minificado
 * a classe `Wa`): mesmos seletores ([data-content], [data-actions], [data-button]), atributo data-height, classes
 * is-open / is-enabled, mesma regra (content.offsetHeight + actions.offsetHeight > data-height), mesmos metodos
 * publicos (setHeight, toggleActions). Carregado com `defer` antes do vendor.js/theme.js no snippets/head.liquid:
 * define o elemento primeiro; o theme.js so define `if (!customElements.get('toggle-ellipsis'))`.
 *
 * Diferencas (SPEC-noite-04-10 §E fase 1, F2a-1), revistas a 05/10 01:3x depois da revisao independente:
 *   (a) as alturas leem-se em callbacks de ResizeObserver (correm depois do layout: sem layout forcado da pagina):
 *       - um RO no [data-content] de cada instancia (mudancas de tamanho do conteudo);
 *       - um RO no <html> que da uma "passagem" depois do 1.o layout, em cada mudanca de LARGURA e quando pedida
 *         (ligacao de instancias novas, theme:collapsible:toggle). Na passagem avaliam-se as instancias que o RO do
 *         conteudo nao ve: dentro de <details> fechado (conteudo saltado: o Chrome nao notifica o RO) ou ainda nao
 *         avaliadas. O original lia-as no arranque, por isso le-las aqui mantem o mesmo estado is-enabled;
 *   (b) nao ouve `theme:resize`: resize so de altura nao mexe no conteudo -> 0 leituras; o de largura e visto pelo RO;
 *       `theme:collapsible:toggle` pede uma passagem (todas as instancias), como o original reavaliava;
 *   (c) uma so chamada a setHeight no connect (a 2.a do original repetia a 1.a);
 *   (d) em cada callback: ler todas as instancias primeiro, escrever todas depois (no proprio callback, antes da
 *       pintura, como o original que escrevia de forma sincrona).
 * Sem ResizeObserver no browser: comportamento original (toggleActions sincrono + `theme:resize`).
 *
 * Reverter: apagar este ficheiro (assets/perf-toggle-ellipsis.js) e as 2 linhas marcadas «PERF 04-10 (F2a-1)» no
 * snippets/head.liquid; o theme.js volta a definir <toggle-ellipsis> como antes.
 */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('toggle-ellipsis')) return;

  var SEL_ACTIONS = '[data-actions]';
  var SEL_CONTENT = '[data-content]';
  var SEL_TRIGGER = '[data-button]';
  var ATTR_HEIGHT = 'data-height';
  var CLS_OPEN = 'is-open';
  var CLS_ENABLED = 'is-enabled';

  var temRO = typeof window.ResizeObserver === 'function' && typeof WeakMap === 'function';
  var instancias = []; // instancias ligadas
  var dono = temRO ? new WeakMap() : null; // [data-content] -> instancia
  var roConteudo = null, roPagina = null;
  var larguraPagina = -1, passagemTodas = false, passagemPedida = false;

  function deveActivar(inst) {
    return inst.content.offsetHeight + inst.actions.offsetHeight > inst.initialHeight;
  }

  // Le todas (layout limpo dentro dos callbacks do RO), depois escreve todas.
  function avalia(lista) {
    var desejado = [];
    for (var i = 0; i < lista.length; i++) desejado.push(deveActivar(lista[i]));
    for (var j = 0; j < lista.length; j++) {
      var inst = lista[j];
      inst._avaliada = true;
      if (inst.classList.contains(CLS_ENABLED) !== desejado[j]) inst.classList.toggle(CLS_ENABLED, desejado[j]);
    }
  }

  function pedePassagem(todas) {
    if (todas) passagemTodas = true;
    if (passagemPedida || !roPagina) return;
    passagemPedida = true;
    // voltar a observar o <html> obriga o RO a notificar depois do proximo layout (nova "notificacao inicial")
    roPagina.unobserve(document.documentElement);
    roPagina.observe(document.documentElement);
  }

  if (temRO) {
    roConteudo = new ResizeObserver(function (entradas) {
      var lista = [];
      for (var i = 0; i < entradas.length; i++) {
        var inst = dono.get(entradas[i].target);
        if (inst && inst.isConnected && lista.indexOf(inst) === -1) lista.push(inst);
      }
      if (lista.length) avalia(lista);
    });
    roPagina = new ResizeObserver(function (entradas) {
      var w = entradas[entradas.length - 1].contentRect.width;
      var mudouLargura = larguraPagina !== -1 && Math.abs(w - larguraPagina) >= 0.5;
      larguraPagina = w;
      var todas = passagemTodas;
      passagemPedida = false; passagemTodas = false;
      var lista = [];
      for (var i = 0; i < instancias.length; i++) {
        var inst = instancias[i];
        if (!inst.isConnected || !inst.content || !inst.actions) continue;
        // as visiveis sao vistas pelo roConteudo; aqui: as nao avaliadas, as em <details> fechado (largura mudou),
        // e todas quando a passagem foi pedida por theme:collapsible:toggle
        if (todas || !inst._avaliada || (mudouLargura && inst.closest('details:not([open])'))) lista.push(inst);
      }
      if (lista.length) avalia(lista);
    });
    roPagina.observe(document.documentElement);
    document.addEventListener('theme:collapsible:toggle', function (e) {
      // Correccao 05/10 03:4x: o fecho animado dos acordeoes do tema (CollapsibleElements.close: altura fixada -> 0 num
      // requestAnimationFrame -> transitionend -> tira o atributo open) so anima se o estilo com a altura fixada for
      // calculado antes de ela passar a 0. No original isso acontecia porque o ToggleEllipsis lia offsetHeight aqui, de
      // forma sincrona; sem essa leitura nao ha transicao nem transitionend e o <details> fica aberto (open="false").
      // Mantem-se UMA leitura sincrona (no corpo do acordeao que mudou), so quando ha instancias na pagina, como no original.
      if (instancias.length) {
        var c = e.target && e.target.closest ? e.target.closest('[data-collapsible]') : null;
        var corpo = c && c.querySelector('[data-collapsible-body]');
        void (corpo || document.documentElement).offsetHeight;
      }
      pedePassagem(true);
    });
  }

  class PerfToggleEllipsis extends HTMLElement {
    constructor() {
      super();
      this.initialHeight = this.getAttribute(ATTR_HEIGHT);
      this.content = this.querySelector(SEL_CONTENT);
      this.trigger = this.querySelector(SEL_TRIGGER);
      this.actions = this.querySelector(SEL_ACTIONS);
      this._avaliada = false;
      this.toggleActions = this.toggleActions.bind(this);
    }

    connectedCallback() {
      // Garante que o valor do data-height bate com o CSS (o original fazia isto duas vezes).
      this.setHeight(this.initialHeight);

      if (this.trigger && !this._cliqueLigado) {
        this._cliqueLigado = true;
        this.trigger.addEventListener('click', () => {
          this.setHeight(this.content.offsetHeight);
          this.classList.add(CLS_OPEN);
        });
      }

      if (temRO && this.content && this.actions) {
        this._avaliada = false;
        if (instancias.indexOf(this) === -1) instancias.push(this);
        dono.set(this.content, this);
        roConteudo.observe(this.content); // conteudo visivel: notificacao depois do 1.o layout
        pedePassagem(false); // conteudo saltado/escondido: avaliado na passagem do roPagina
      } else {
        this.toggleActions();
        document.addEventListener('theme:resize', this.toggleActions);
        document.addEventListener('theme:collapsible:toggle', this.toggleActions);
      }
    }

    disconnectedCallback() {
      if (temRO && this.content && this.actions) {
        roConteudo.unobserve(this.content);
        var i = instancias.indexOf(this);
        if (i !== -1) instancias.splice(i, 1);
      } else {
        document.removeEventListener('theme:resize', this.toggleActions);
        document.removeEventListener('theme:collapsible:toggle', this.toggleActions);
      }
    }

    setHeight(contentHeight) {
      this.style.setProperty('--height', contentHeight + 'px');
    }

    // Metodo publico igual ao original (sincrono), para quem o chamar de fora.
    toggleActions() {
      this.classList.toggle(CLS_ENABLED, deveActivar(this));
    }
  }

  customElements.define('toggle-ellipsis', PerfToggleEllipsis);
})();
